// Innconsistencies
export const REQUEST_ASSOCIATIONS = '@main/REQUEST_ASSOCIATIONS';
export const SET_LIST_ASSOCIATIONS = '@main/SET_LIST_ASSOCIATIONS';
export const FETCH_LIST_ASSOCIATIONS = '@main/FETCH_LIST_ASSOCIATIONS';
